import store from '../store'

//Role types
export const ADMINISTRATIVE = 2
export const SPECIALIST = 3
export const TECHNOLOGIST = 4

//Specialties
export const OPHTHALMOLOGY = 'Oftalmología'
export const PSYCHOLOGY = 'Psicología'
export const GENERAL_MEDICINE = 'Medicina General'
export const MEDICAL_TECHNOLOGY = 'Tecnología Médica'
export const OTHER = 'Otro'

export const ALLOWED_SPECIALTIES_TO_CHOOSE_TEMPLATE = [
    OPHTHALMOLOGY,
    GENERAL_MEDICINE,
]

export const userRoleIs = (roleId) => {

    const currentProvider = store.state.currentProvider
    if(!currentProvider) return false

    const role = currentProvider.role
    if(!role) return false

    if(!role || !role.id) return false

    return role.id === roleId

}

export const userProvides = (specialty) => {

    const currentProvider = store.state.currentProvider
    if(!currentProvider) return false

    const role = currentProvider.role
    if(!role) return false

    if(!role || !role.id) return false

    var specialties = role && role.services_labels || []
    if(!specialties || specialties.length === 0) return false

    return specialties.includes(specialty)

}

export const userProvidesOneOf = (specialties) => {

    const currentProvider = store.state.currentProvider
    if(!currentProvider) return false

    const role = currentProvider.role
    if(!role) return false

    if(!role || !role.id) return false

    var specialistServices = role && role.services_labels || []
    if(!specialistServices || specialistServices.length === 0) return false

    for(let specialty of specialties){
        if(specialistServices.includes(specialty)){
            return true
        }
    }

    return false

}

export const appointmentConfigComponent = (specialty) => {

    if(specialty === PSYCHOLOGY){
        return 'PsychologistAppointmentConfig'
    }

    return 'StandardAppointmentConfig'

}

export const isHealthSpecialist = () => {

    return (
        userProvides(PSYCHOLOGY)
        || userProvides(MEDICAL_TECHNOLOGY)
        || userProvides(GENERAL_MEDICINE)
        || userProvides(OPHTHALMOLOGY)
    )

}

export const isClinicalSpecialist = () => {

    return (
        userProvides(MEDICAL_TECHNOLOGY)
        || userProvides(GENERAL_MEDICINE)
        || userProvides(OPHTHALMOLOGY)
    )

}

export const needsExamConfig = () => {

    // Especialidades cuya ficha incluye la sección "Exámen Físico" (PhysicalExams)
    if(userProvides(OPHTHALMOLOGY) || userProvides(MEDICAL_TECHNOLOGY)){
        return true
    }

    return false

}

export const isAttentionComponentTypeChoiceAvailable = () => {
    return userProvidesOneOf(ALLOWED_SPECIALTIES_TO_CHOOSE_TEMPLATE);
}

export const attentionComponentByService = (service = OTHER) => {

    const settings = store.getters.specialistSettings

    if(ALLOWED_SPECIALTIES_TO_CHOOSE_TEMPLATE.includes(service) &&
        (settings && settings.attention_template === 'simple')){
        return 'SimpleAttention'
    }

    switch(service){
        case MEDICAL_TECHNOLOGY:
            return 'MedicalTechnologyAttention';
        case PSYCHOLOGY:
            return 'PsychologicalAttention';
        case OPHTHALMOLOGY:
            return 'OphthalmologicalAttention';
        case GENERAL_MEDICINE:
            return 'GeneralMedicineAttention';
        default:
            return 'SimpleAttention';
    }

}

export const endAttentionComponentByService = (service = OTHER) => {

    switch(service){
        case PSYCHOLOGY:
            return 'PsychologistEndAttention';
        case MEDICAL_TECHNOLOGY:
            return 'TechnologistEndAttention';
        default:
            return 'DefaultEndAttention';
    }

}

export const requiresGlobalSpinner = () => {

    if(userProvides(PSYCHOLOGY)){
        return true
    }

    return false

}

export const getRole = () => {

    const currentProvider = store.state.currentProvider
    if(!currentProvider) return null

    return currentProvider.role || null

}
